import { defineComponent as _defineComponent } from 'vue'
import { DfrEntry } from '@newmoon-org/shared';
import { ref, computed } from 'vue';
import { DateService } from '@newmoon-org/shared';
import { DialogProgrammatic } from 'buefy';

import { db } from '@/service/firebase.js';

import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'DfrReportView',
  props: {
    dfr: null
  },
  setup(__props: any) {

const props = __props as {
  dfr: DfrEntry;
}

const { employee } = store.getters['auth/user'];



const dfr = ref<DfrEntry>(props.dfr);

const hasReport = computed<boolean>(() => {
  return dfr.value.report?.generated;
});

const hasSageReport = computed<boolean>(() => {
  return dfr.value.sageReport?.generated;
});

const canSee = computed<boolean>(() => {
  return ['hr', 'administrator'].includes(employee.workflowFunction?.name?.toLowerCase());
});

const generatedAt = computed<string | null>(() => {
  return dfr.value.report?.date ? DateService.convertToDate(props.dfr.report.date) : null;
});

const sageGeneratedAt = computed<string | null>(() => {
  return dfr.value.sageReport?.date ? DateService.convertToDate(props.dfr.sageReport.date) : null;
});

const isLoading = ref<boolean>(false);
const isSageLoading = ref<boolean>(false);

async function markGenerated(isGenerated: boolean): Promise<void> {
  if (!dfr.value.id) return;

  const { result } = await DialogProgrammatic.confirm({
    message: 'Are you sure you want to release this report?',
  });

  if (!result) return;

  isLoading.value = true;
  await db
    .collection('dfr')
    .doc(dfr.value.id)
    .set(
      {
        report: {
          generated: isGenerated,
        },
      },
      { merge: true }
    );

  dfr.value.report.generated = false;
  isLoading.value = false;
}

async function markSageGenerated(isGenerated: boolean): Promise<void> {
  if (!dfr.value.id) return;

  const { result } = await DialogProgrammatic.confirm({
    message: 'Are you sure you want to release this Sage report?',
  });

  if (!result) return;

  isSageLoading.value = true;
  await db
    .collection('dfr')
    .doc(dfr.value.id)
    .set(
      {
        sageReport: {
          generated: isGenerated,
        },
      },
      { merge: true }
    );

  if (!dfr.value.sageReport) {
    dfr.value.sageReport = { generated: false, date: null, taskId: '' };
  } else {
    dfr.value.sageReport.generated = false;
  }
  isSageLoading.value = false;
}

return { __sfc: true,employee, props, dfr, hasReport, hasSageReport, canSee, generatedAt, sageGeneratedAt, isLoading, isSageLoading, markGenerated, markSageGenerated }
}

})